export default "__VITE_ASSET__BLfK6JFr__"